
import api from '@/api/_constantes-catalogue'
import { validerIntervalles, badgeIntervalle } from '@/utils/constantes-catalogue'

const copie = value => JSON.parse(JSON.stringify(value))
const COULEUR = /^#[0-9a-f]{6}$/i
const sans_brouillon = message => message.replace(/ ?Le brouillon est conservé\.$/, '').replace(/ ; le brouillon est conservé\./, '.')
// Identifiants temporaires de brouillon, jamais des capacités ou des secrets.
const identifiant = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, letter => {
    const number = Math.floor(Math.random() * 16)
    return (letter === 'x' ? number : (number & 3) | 8).toString(16)
})
export default {
    name: 'constantes-catalogue',
    props: {
        onlyField: { type: String, default: null },
        excludeField: { type: String, default: null }
    },
    data() {
        return { catalogue: null, brouillon: null, suppression: null, menu_ouvert: null, etape: 0, recherche: '', chargement: false, enregistrement: false,
            erreur: '', succes: '', apercu_valeur: '', apercu_unite: '', apercu_profil: 'general', requete: 0, detruit: false,
            etapes: ['Champ et unités', 'Intervalles et badges', 'Vérification', 'Accessibilité'],
            couleurs_visible: false, couleurs: null, couleurs_defaut: {}, couleurs_chargement: false, couleurs_enregistrement: false, couleurs_erreur: '', couleurs_requete: 0,
            elements_feuille: [{ key: 'diurese', label: 'Diurèse (mL)' }, { key: 'ta', label: 'T.A (cmHg)' }, { key: 'pouls', label: 'Pouls (bpm)' },
                { key: 'fr', label: 'F.R (c/min)' }, { key: 'temperature', label: 'T° (°C)' }, { key: 'repere_37', label: 'Repère 37 °C' }] }
    },
    computed: {
        nouveau_champ() { return !!(this.brouillon && this.brouillon.key.indexOf('new:') === 0) },
        occurrences_texte: {
            get() { return this.brouillon ? (this.brouillon.occurrences || []).join('\n') : '' },
            set(value) { if (!this.enregistrement) this.brouillon.occurrences = value.split('\n').map(item => item.trim()).filter(Boolean) }
        },
        profil_reference() {
            const reference = this.brouillon && this.brouillon.reference_profile
            return reference && this.catalogue && (this.catalogue.profiles || []).find(profile => profile.code === reference.code && profile.version === reference.version)
        },
        intervalles_editables() {
            return !!(this.brouillon && this.contextes.length && ['number', 'calculated'].indexOf(this.brouillon.kind) >= 0
                && (!this.profil_reference || this.profil_reference.editable_intervals !== false))
        },
        contextes() { return this.profil_reference ? this.profil_reference.contexts || ['general'] : this.personnalise ? ['general'] : [] },
        badge_apercu() { return this.erreurs_validation.length ? null : badgeIntervalle(this.brouillon, this.apercu_valeur, this.apercu_unite, this.apercu_profil) },
        erreurs_validation() {
            if (!this.brouillon) return []
            const field = this.brouillon, errors = validerIntervalles(field)
            if (!String(field.label || '').trim()) errors.push('Renseignez le nom de la constante.')
            if (!Number.isSafeInteger(field.position) || field.position < 0) errors.push('La position doit être un entier positif ou nul.')
            if (field.units.length && !field.units.some(unit => unit.code === field.default_unit)) errors.push('Choisissez une unité par défaut.')
            const labels = field.units.map(unit => String(unit.label || '').trim().toLocaleLowerCase())
            if (labels.some(label => !label) || new Set(labels).size !== labels.length) errors.push('Chaque unité doit avoir un libellé distinct et non vide.')
            if (field.intervals.some(rule => !field.units.some(unit => unit.code === rule.unit))) errors.push('Chaque intervalle doit utiliser une unité du champ.')
            if (field.kind === 'choice' && !(field.occurrences || []).length) errors.push('Renseignez au moins une option pour le champ à choix.')
            if (['number', 'pressure', 'calculated'].indexOf(field.kind) < 0 && field.units.length) errors.push('Retirez les unités pour un champ non numérique.')
            return errors
        },
        couleurs_valides() { return !!this.couleurs && this.elements_feuille.every(element => this.couleur_valide(this.couleurs[element.key])) },
        personnalise() { return !!(this.brouillon && /^(champ|new):/.test(this.brouillon.key)) },
        types() { return this.catalogue ? this.catalogue.types || [] : [] },
        specialites() { return this.catalogue ? this.catalogue.specialties || [] : [] },
        specialites_choisies() { return this.brouillon && this.brouillon.specialty_ids === null ? this.specialites.map(item => item.id) : this.brouillon && this.brouillon.specialty_ids || [] },
        toutes_specialites() { return !!(this.brouillon && (this.brouillon.specialty_ids === null || (this.specialites.length > 0 && this.specialites_choisies.length === this.specialites.length))) },
        specialites_partielles() { return this.specialites_choisies.length > 0 && !this.toutes_specialites },
        autorise() { return !!(this.$store.getters.activeRole && this.$store.getters.activeRole.nom === 'ROLE_ADMINISTRATEUR') },
        acteur() { const auth = this.$store.getters.authInfo; return auth && auth.user && auth.user.id },
        champs() {
            if (!this.catalogue) return []
            const recherche = this.recherche.trim().toLocaleLowerCase()
            return this.catalogue.fields.filter(field =>
                (!this.onlyField || field.key === this.onlyField)
                && (!this.excludeField || field.key !== this.excludeField)
                && !field.archived
                && field.label.toLocaleLowerCase().indexOf(recherche) >= 0
            ).slice().sort((a, b) => a.position - b.position)
        }
    },
    watch: { autorise() { this.invalider() }, acteur() { this.invalider() } },
    mounted() { return this.charger_catalogue() },
    beforeDestroy() { this.detruit = true; this.invalider() },
    methods: {
        invalider() { this.requete++; this.catalogue = null; this.brouillon = null; this.suppression = null; this.menu_ouvert = null; this.chargement = false; this.enregistrement = false },
        async capacite() {
            const access = await api.getConstantesCatalogueAccess()
            if (!access || access.success !== true || !access.data || typeof access.data.access_token !== 'string' || !access.data.access_token) throw Error('Capacité absente')
            return access.data.access_token
        },
        async charger_catalogue() {
            if (!this.autorise || this.detruit || this.enregistrement || this.brouillon) return
            const requete = ++this.requete
            this.chargement = true; this.erreur = ''
            try {
                const token = await this.capacite()
                if (!this.autorise || this.detruit || requete !== this.requete) return
                const response = await api.getConstantesCatalogue(token)
                if (!this.autorise || this.detruit || requete !== this.requete) return
                if (!response || response.schema_version !== 1 || !response.etag || !Array.isArray(response.fields)) throw Error('Catalogue incomplet')
                this.catalogue = response
            } catch (error) {
                if (!this.detruit && requete === this.requete) this.erreur = this.message_erreur(error)
            } finally { if (!this.detruit && requete === this.requete) this.chargement = false }
        },
        editer(field) {
            if (!this.autorise || this.enregistrement || this.chargement) return
            this.brouillon = copie(field); this.etape = 0; this.erreur = ''; this.succes = ''
            if (typeof this.brouillon.show_badge !== 'boolean') this.$set(this.brouillon, 'show_badge', true)
            this.apercu_valeur = ''; this.apercu_unite = field.default_unit; this.apercu_profil = this.contextes[0] || 'general'
        },
        demander_suppression(field) {
            if (!this.autorise || this.enregistrement || this.chargement || field.archived) return
            this.menu_ouvert = null; this.suppression = { key: field.key, label: field.label }; this.erreur = ''; this.succes = ''
        },
        annuler_suppression() { if (!this.enregistrement) this.suppression = null },
        async confirmer_suppression() {
            if (!this.autorise || this.detruit || this.enregistrement || !this.catalogue || !this.suppression) return
            const target = this.suppression, requete = ++this.requete
            const fields = this.catalogue.fields.map(field => field.key === target.key
                ? Object.assign({}, copie(field), { archived: true, enabled: false, required: false }) : copie(field))
            this.enregistrement = true; this.erreur = ''; this.succes = ''
            try {
                const token = await this.capacite()
                if (!this.autorise || this.detruit || requete !== this.requete) return
                const response = await api.saveConstantesCatalogue({ base_etag: this.catalogue.etag, fields }, token)
                if (!this.autorise || this.detruit || requete !== this.requete) return
                if (!response || response.schema_version !== 1 || !response.etag || !Array.isArray(response.fields)) throw Error('Catalogue incomplet')
                this.catalogue = response; this.suppression = null
                this.succes = 'Constante supprimée des nouvelles saisies. Les mesures antérieures sont conservées.'
            } catch (error) {
                if (!this.detruit && requete === this.requete) this.erreur = sans_brouillon(this.message_erreur(error))
            } finally { if (!this.detruit && requete === this.requete) this.enregistrement = false }
        },
        nouveau() {
            if (!this.autorise || this.enregistrement || this.chargement || !this.types.length) return
            const type = this.types[0]
            this.editer({ key: 'new:' + identifiant(), champ_id: null, label: 'Nouvelle constante', kind: type.kind, type_champ_id: type.id,
                enabled: true, show_badge: true, required: false, position: Math.max(0, ...this.catalogue.fields.map(field => field.position)) + 1,
                units: [], allowed_units: [], default_unit: null, specialty_ids: [], reference_profile: null, intervals: [], occurrences: [] })
        },
        changer_type(id) {
            const type = this.types.find(item => item.id === Number(id))
            if (this.enregistrement || !this.nouveau_champ || !type) return
            this.brouillon.type_champ_id = type.id; this.brouillon.kind = type.kind
        },
        ajouter_unite() {
            if (this.enregistrement || !this.personnalise || this.brouillon.kind !== 'number') return
            const unit = { code: 'custom:' + identifiant(), label: '' }
            this.brouillon.units.push(unit)
            if (!this.brouillon.default_unit) this.brouillon.default_unit = unit.code
        },
        supprimer_unite(index) {
            if (this.enregistrement || !this.personnalise) return
            const unit = this.brouillon.units.splice(index, 1)[0]
            if (unit.code === this.brouillon.default_unit) this.brouillon.default_unit = this.brouillon.units.length ? this.brouillon.units[0].code : null
        },
        annuler() { if (!this.enregistrement) { this.brouillon = null; this.erreur = '' } },
        couleur_valide(value) { return typeof value === 'string' && COULEUR.test(value) },
        async ouvrir_couleurs() {
            if (!this.autorise || this.chargement) return
            const requete = ++this.couleurs_requete
            this.couleurs_visible = true; this.couleurs = null; this.couleurs_erreur = ''; this.couleurs_chargement = true; this.succes = ''
            try {
                const token = await this.capacite()
                if (this.detruit || requete !== this.couleurs_requete) return
                const response = await api.getSurveillanceCouleurs(token)
                if (this.detruit || requete !== this.couleurs_requete) return
                if (!response || !response.couleurs || !response.defauts) throw Error('Couleurs incomplètes')
                this.couleurs_defaut = response.defauts; this.couleurs = Object.assign({}, response.couleurs)
            } catch (error) {
                if (!this.detruit && requete === this.couleurs_requete) this.couleurs_erreur = sans_brouillon(this.message_erreur(error))
            } finally { if (!this.detruit && requete === this.couleurs_requete) this.couleurs_chargement = false }
        },
        fermer_couleurs() { if (!this.couleurs_enregistrement) { this.couleurs_requete++; this.couleurs_visible = false; this.couleurs_chargement = false } },
        async enregistrer_couleurs() {
            if (!this.autorise || this.couleurs_enregistrement || !this.couleurs_valides) return
            const requete = ++this.couleurs_requete, couleurs = {}
            this.elements_feuille.forEach(element => { couleurs[element.key] = this.couleurs[element.key].toLowerCase() })
            this.couleurs_enregistrement = true; this.couleurs_erreur = ''
            try {
                const token = await this.capacite()
                if (this.detruit || requete !== this.couleurs_requete) return
                const response = await api.saveSurveillanceCouleurs(couleurs, token)
                if (this.detruit || requete !== this.couleurs_requete) return
                if (!response || !response.couleurs) throw Error('Couleurs incomplètes')
                this.couleurs_enregistrement = false; this.fermer_couleurs(); this.succes = 'Couleurs de la feuille de surveillance enregistrées.'
            } catch (error) {
                if (!this.detruit && requete === this.couleurs_requete) this.couleurs_erreur = sans_brouillon(this.message_erreur(error))
            } finally { if (!this.detruit && requete === this.couleurs_requete) this.couleurs_enregistrement = false }
        },
        aller_etape(etape) { if (!this.enregistrement) this.etape = Math.max(0, Math.min(3, etape)) },
        clavier_etape(event, index) {
            if (this.enregistrement) return
            const cible = { ArrowRight: (index + 1) % 4, ArrowLeft: (index + 3) % 4, Home: 0, End: 3 }[event.key]
            if (cible === undefined) return
            event.preventDefault(); this.aller_etape(cible)
            const button = event.currentTarget.parentElement.querySelectorAll('button')[cible]
            if (button) button.focus()
        },
        choisir_toutes(checked) { if (!this.enregistrement) this.brouillon.specialty_ids = checked ? this.specialites.map(item => item.id) : [] },
        choisir_specialite(id, checked) {
            if (this.enregistrement) return
            this.brouillon.specialty_ids = this.specialites_choisies.filter(value => value !== id)
            if (checked) this.brouillon.specialty_ids.push(id)
        },
        borne(rule, key, value) {
            if (this.enregistrement) return
            rule[key] = value.trim() === '' ? null : value
            if (rule[key] === null) rule[key + '_inclusive'] = false
        },
        ajouter_intervalle() {
            if (this.enregistrement || !this.intervalles_editables || !this.brouillon.units.length) return
            let index = 1
            while (this.brouillon.intervals.some(rule => rule.id === 'intervalle-' + index)) index++
            this.brouillon.intervals.push({ id: 'intervalle-' + index, unit: this.brouillon.default_unit,
                profile: this.contextes[0] || 'general', lower: null, upper: null, lower_inclusive: false, upper_inclusive: false, label: '', tone: 'neutral' })
        },
        supprimer_intervalle(index) { if (!this.enregistrement && this.intervalles_editables) this.brouillon.intervals.splice(index, 1) },
        message_erreur(error) {
            const response = error && error.response, status = response && response.status
            if (status === 401) return 'Session ou accès expiré. Reconnectez-vous si nécessaire puis réessayez ; le brouillon est conservé.'
            if (status === 403) return 'Vous n’êtes pas autorisé à modifier ce catalogue. Le brouillon est conservé.'
            if (status === 409) return 'Le catalogue a été modifié ailleurs : conflit de version. Votre brouillon est conservé. Annulez puis rechargez pour comparer avant de recommencer.'
            if (status === 422) {
                const errors = response.data && response.data.errors || {}
                const details = Object.keys(errors).map(key => Array.isArray(errors[key]) ? errors[key].join(' ') : String(errors[key])).join(' ')
                return 'Configuration refusée. ' + (details || 'Vérifiez les champs et les intervalles.') + ' Le brouillon est conservé.'
            }
            if (status === 503) return 'Le catalogue ou son accès n’est pas disponible. Contactez votre administrateur. Le brouillon est conservé.'
            return 'La configuration n’a pas pu être confirmée. Vérifiez la connexion ; le brouillon est conservé.'
        },
        async enregistrer() {
            if (!this.autorise || this.detruit || this.enregistrement || !this.brouillon || this.etape !== 3 || this.erreurs_validation.length) return
            const requete = ++this.requete, draft = copie(this.brouillon)
            const fields = this.catalogue.fields.map(field => field.key === draft.key ? draft : copie(field))
            if (!fields.some(field => field.key === draft.key)) fields.push(draft)
            fields.forEach(field => field.intervals.forEach(rule => {
                if (typeof rule.lower === 'string') rule.lower = rule.lower.trim().replace(',', '.')
                if (typeof rule.upper === 'string') rule.upper = rule.upper.trim().replace(',', '.')
            }))
            const payload = { base_etag: this.catalogue.etag, fields }
            this.enregistrement = true; this.erreur = ''; this.succes = ''
            try {
                const token = await this.capacite()
                if (!this.autorise || this.detruit || requete !== this.requete) return
                const response = await api.saveConstantesCatalogue(payload, token)
                if (!this.autorise || this.detruit || requete !== this.requete) return
                if (!response || response.schema_version !== 1 || !response.etag || !Array.isArray(response.fields)) throw Error('Catalogue incomplet')
                this.catalogue = response; this.brouillon = null; this.succes = 'Configuration enregistrée.'
            } catch (error) {
                if (!this.detruit && requete === this.requete) this.erreur = this.message_erreur(error)
            } finally { if (!this.detruit && requete === this.requete) this.enregistrement = false }
        }
    }
}
